/**
 * Validation utility functions
 */

/**
 * Validate NID images
 * @param {Object} images - Object with front and back image data URLs
 * @returns {boolean} True if both images are present
 */
export const validateNidImages = (images) => {
  if (!images) return false;
  return !!(images.front && images.back);
};
